export const projectData = [
    {
      path: 'OneHitWonders',
      title: 'One-Hit-Wonders',
      githubLink: 'https://github.com/colestephenson1/one-hit-wonderz',
      technologies: 'JavaScript | React | HTML/CSS | React Router | Express | PostgreSQL | Knex | Cypress',
      overview: 'This application allows you to explore most of the one hit wonders that occured between six different decades. Users can listen to a song as much as they like and find one hit wonders that fit their current mood',
      wins: [
        'Creating a backend server for the first time using Express, PostgreSQL, and Knex',
        'Having the backend server deployed and being able to connect our front end to the backend',
        'Working with two other front end developers to create a fullstack application'
      ],
      challenges: [
        'First time trying to create a backend server as a front end developer. It was a struggle figuring out where to get started and how to deploy our server properly so that we could access our endpoints '
      ],
      images: [
        {
          link: 'https://user-images.githubusercontent.com/100726140/191096910-fa024654-646b-4e0b-b8ba-26e237f3c654.png',
        }
        
      ]
    },
    {
      path: 'heatCheck',
      title: 'Heat-Check',
      githubLink: 'https://github.com/HeatChecc/Heat-Check-FE',
      technologies: 'React | Apollo | GraphQL | Cypress | React Router',
      overview: 'Need to spice up your life? This application lets users search for spicy food places near your city/address. Users can leave reviews for dishes they`ve had at certain restaurants',
      wins: [
       'Achieved MVP with extensions before deadline',
       'Successful workflow and communication between FE and BE teams',
       'implementing a map section so that users may see different restaurant locations on a map instead of a list view if they wanted to change it up'
      ],
      challenges: [
       'Learning GraphQL and how to make query mutations',
       'first time implementing continous intergration with github actions',
       'COVID-19 impacts including with remote work involving communication between both teams'
      ],
      images: [
       {
         link: 'https://user-images.githubusercontent.com/96998327/198336261-ab237841-4149-4d8a-b569-1b648b256a3c.png',
       }
      ]
    },
    {
      path: 'amiiwho',
      title: 'AmiiWho',
      githubLink: 'https://github.com/INguyen22/amiiWho',
      technologies: 'JavaScript | React | HTML/CSS | Cypress | React Router',
      overview: 'This app allows users to search for amiibos Nintendo has released over the years and find out what special features that amiibo can unlock in different games! Users can search amiibos by name or series and favorite/unfavorite amiibos ',
      wins: [
       'Showing off understanding of React',
       'Getting SOLID MVP through use of iterations and project board'
      ],
      challenges: [
       'Creating a favoriting function in react that persisted through page reload',
       'Dynamic functions to dry up form methods',
      ],
      images: [
        {
          link: 'https://user-images.githubusercontent.com/100492419/192118546-c0318dfd-0c30-42d4-8bbe-b789293b5c36.gif'
        }
      ]
    }
  ]